import { initialsOf, tintFor } from "@/lib/tints.ts";
import { cn } from "@/lib/utils.ts";

interface Props {
  name: string;
  /** Semilla del color; sin ella, el propio nombre. */
  seed?: string;
  /** Texto en lugar de las iniciales (p. ej. el número de una caja). */
  text?: string;
  /** Cuadro redondeado para cosas; círculo para personas. */
  square?: boolean;
  className?: string;
}

/** Iniciales sobre un color estable: personas, categorías, marcas, sucursales. */
export function Avatar({ name, seed, text, square, className }: Props) {
  const [background, color] = tintFor(seed ?? name);
  return (
    <div
      className={cn(
        "flex h-10 w-10 shrink-0 items-center justify-center text-sm font-extrabold",
        square ? "rounded-xl" : "rounded-full",
        className,
      )}
      style={{ background, color }}
      aria-hidden="true"
    >
      {text ?? (initialsOf(name) || "?")}
    </div>
  );
}
